/**
 * 在这些页面里只隐藏左上角 index-icons 中的 Instagram / 小红书 图标，
 * 分享按钮会保留。
 * 需要新增页面时，直接往列表里加一行，例如：
 *   "/about"
 * 只填 path 即可；匹配时会忽略域名、# 前缀和 query。
 */
export const pagesWithoutInstagramRedIcons = [
    "/creator-partnerships",
    "/about",
    "/contact",
];

function normalizeRoute(value) {
    let route = String(value || "")
        .trim()
        .replace(/^https?:\/\/[^/]+/, "")
        .replace(/^[#/]+/, "/")
        .replace(/^\/+/, "/")
        .replace(/[?#].*$/, "")
        .replace(/\/+$/, "")
        .toLowerCase();

    return route || "/";
}

export function shouldHideInstagramRedIcons(pathname) {
    const current = normalizeRoute(pathname);
    return pagesWithoutInstagramRedIcons.some((page) => normalizeRoute(page) === current);
}
